
import img1 from '../img/1bus.jpg';
import img2 from '../img/2pos.jpg';
import img3 from '../img/3mug.jpg';
import img4 from '../img/4wed.jpg';
import img5 from '../img/5goo.jpg';
import img6 from '../img/6fav.jpg';
import img7 from '../img/7cap.jpg';
import img8 from '../img/8sti.jpg';

let cardData = [
    {
        img: img1,
        name: "BUSINESS CARD"
    },
    {
        img: img2,
        name: "POSTER"
    },
    {
        img: img3,
        name: "MUG"
    },
    {
        img: img4,
        name: "WEDDING CARDS"
    },
    {
        img: img5,
        name: "GOODIE BAGS"
    },
    {
        img: img6,
        name: "FAVOR BOXES"
    },
    {
        img: img7,
        name: "CAPS"
    },
    {
        img: img8,
        name: "STICKERS"
    },
]

export default cardData;